import { useState } from "react";
import { useSelector } from "react-redux";
import ChangePasswordModal from "../../../pages/auth/change password";
import SignoutModal from "../../../pages/auth/signout";
import Image from "../../UI/Image";
import "./style.scss";
import { textIdentifier } from "../../../textIdentifier";

export default function PrimaryHeader() {
  const userData = useSelector((state) => state.auth.userData);
  // const userData = {
  //   profileImage: "https://via.placeholder.com/150",
  //   first_name: "Nomesh",
  // };

  const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);
  const [showSignoutModal, setShowSignoutModal] = useState(false);

  const handleShowChangePasswordModal = () => setShowChangePasswordModal(true);
  const handleCloseChangePasswordModal = () =>
    setShowChangePasswordModal(false);

  const handleShowSignoutModal = () => setShowSignoutModal(true);
  const handleCloseSignoutModal = () => setShowSignoutModal(false);

  const {lang} = useSelector(state => state.main)

  return (
    <header>
      <nav className="nav">
        <h3>{userData.organization}</h3>

        <div className="dropdown">
          <button
            className="btn dropdown-toggle"
            type="button"
            id="dropdownMenuButton1"
            data-bs-toggle="dropdown"
            data-bs-offset="50,12"
            aria-expanded="false"
          >
            <Image src={userData.profileImage} alt={userData.first_name} />

            <span>{textIdentifier["hi"][lang]}, {userData.first_name}</span>

            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.46895 11.6681C8.76899 11.3682 9.17588 11.1997 9.60015 11.1997C10.0244 11.1997 10.4313 11.3682 10.7313 11.6681L16.0001 16.9369L21.2689 11.6681C21.4165 11.5153 21.5931 11.3934 21.7883 11.3096C21.9835 11.2257 22.1935 11.1816 22.4059 11.1797C22.6184 11.1779 22.829 11.2184 23.0257 11.2988C23.2223 11.3793 23.4009 11.4981 23.5512 11.6483C23.7014 11.7985 23.8202 11.9772 23.9007 12.1738C23.9811 12.3705 24.0216 12.5811 24.0197 12.7936C24.0179 13.006 23.9738 13.216 23.8899 13.4112C23.8061 13.6064 23.6842 13.783 23.5313 13.9305L17.1313 20.3305C16.8313 20.6305 16.4244 20.799 16.0001 20.799C15.5759 20.799 15.169 20.6305 14.8689 20.3305L8.46895 13.9305C8.16899 13.6305 8.00049 13.2236 8.00049 12.7993C8.00049 12.3751 8.16899 11.9682 8.46895 11.6681Z"
                fill="white"
              />
            </svg>
          </button>

          <ul
            className="dropdown-menu shadow"
            aria-labelledby="dropdownMenuButton1"
          >
            <li>
              <a
                className="dropdown-item"
                onClick={(e) => {
                  e.preventDefault();
                  handleShowChangePasswordModal();
                }}
              >
                {textIdentifier['change-password'][lang]}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 42 42"
                  fill="none"
                >
                  <path
                    d="M13.7117 8.21973C14.967 8.11954 16.1587 7.62596 17.1172 6.80923C18.2003 5.8857 19.5771 5.37842 21.0005 5.37842C22.4238 5.37842 23.8006 5.8857 24.8837 6.80923C25.8422 7.62596 27.0339 8.11954 28.2892 8.21973C29.708 8.33261 31.0402 8.94743 32.0466 9.95385C33.053 10.9603 33.6678 12.2924 33.7807 13.7112C33.8809 14.9665 34.3745 16.1582 35.1912 17.1167C36.1148 18.1998 36.622 19.5766 36.622 21C36.622 22.4234 36.1148 23.8001 35.1912 24.8832C34.3745 25.8417 33.8809 27.0334 33.7807 28.2887C33.6678 29.7076 33.053 31.0397 32.0466 32.0461C31.0402 33.0525 29.708 33.6674 28.2892 33.7802C27.0339 33.8804 25.8422 34.374 24.8837 35.1907C23.8006 36.1143 22.4238 36.6216 21.0005 36.6216C19.5771 36.6216 18.2003 36.1143 17.1172 35.1907C16.1587 34.374 14.967 33.8804 13.7117 33.7802C12.2929 33.6674 10.9608 33.0525 9.95434 32.0461C8.94791 31.0397 8.3331 29.7076 8.22022 28.2887C8.12003 27.0334 7.62645 25.8417 6.80972 24.8832C5.88619 23.8001 5.37891 22.4234 5.37891 21C5.37891 19.5766 5.88619 18.1998 6.80972 17.1167C7.62645 16.1582 8.12003 14.9665 8.22022 13.7112C8.3331 12.2924 8.94791 10.9603 9.95434 9.95385C10.9608 8.94743 12.2929 8.33261 13.7117 8.21973Z"
                    stroke="#2E2E2E"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M17.5 19.25V15.75C17.5 14.8217 17.8687 13.9315 18.5251 13.2751C19.1815 12.6187 20.0717 12.25 21 12.25C21.9283 12.25 22.8185 12.6187 23.4749 13.2751C24.1313 13.9315 24.5 14.8217 24.5 15.75M21 22.75V24.5M15.75 28H26.25C26.7141 28 27.1592 27.8156 27.4874 27.4874C27.8156 27.1592 28 26.7141 28 26.25V21C28 20.5359 27.8156 20.0908 27.4874 19.7626C27.1592 19.4344 26.7141 19.25 26.25 19.25H15.75C15.2859 19.25 14.8408 19.4344 14.5126 19.7626C14.1844 20.0908 14 20.5359 14 21V26.25C14 26.7141 14.1844 27.1592 14.5126 27.4874C14.8408 27.8156 15.2859 28 15.75 28Z"
                    stroke="#2E2E2E"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </a>
            </li>

            <li>
              <a
                className="dropdown-item"
                onClick={(e) => {
                  e.preventDefault();
                  handleShowSignoutModal();
                }}
              >
               {textIdentifier['logout'][lang]}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 34 30"
                  fill="none"
                >
                  <path
                    d="M18.75 22V23.75C18.75 25.1424 18.1969 26.4777 17.2123 27.4623C16.2277 28.4469 14.8924 29 13.5 29H6.5C5.10761 29 3.77226 28.4469 2.78769 27.4623C1.80312 26.4777 1.25 25.1424 1.25 23.75V6.25C1.25 4.85761 1.80312 3.52226 2.78769 2.53769C3.77226 1.55312 5.10761 1 6.5 1H13.5C14.8924 1 16.2277 1.55312 17.2123 2.53769C18.1969 3.52226 18.75 4.85761 18.75 6.25V8M25.75 22L32.75 15L25.75 22ZM32.75 15L25.75 8L32.75 15ZM32.75 15H8.25H32.75Z"
                    stroke="#2E2E2E"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </a>
            </li>
          </ul>
        </div>
      </nav>

      {/* Logout Modal */}
      {showSignoutModal && (
        <SignoutModal handleClose={handleCloseSignoutModal} />
      )}
      {/* Change Password Modal */}
      {showChangePasswordModal && (
        <ChangePasswordModal handleClose={handleCloseChangePasswordModal} />
      )}
    </header>
  );
}
